// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree__learning-outcome[data-v-0affde48]{margin-bottom:5rem}", ""]);
// Exports
module.exports = exports;
